export default "__VITE_ASSET__5UdYBdgj__"